import { render, staticRenderFns } from "./DiscountBar.vue?vue&type=template&id=5ea9fffc&scoped=true"
import script from "./DiscountBar.vue?vue&type=script&lang=js"
export * from "./DiscountBar.vue?vue&type=script&lang=js"
import style0 from "./DiscountBar.vue?vue&type=style&index=0&id=5ea9fffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea9fffc",
  null
  
)

export default component.exports